import { render, staticRenderFns } from "./many-select.vue?vue&type=template&id=6148c23a&"
import script from "./many-select.vue?vue&type=script&lang=js&"
export * from "./many-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/spee2/www/univers/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6148c23a')) {
      api.createRecord('6148c23a', component.options)
    } else {
      api.reload('6148c23a', component.options)
    }
    module.hot.accept("./many-select.vue?vue&type=template&id=6148c23a&", function () {
      api.rerender('6148c23a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/forms/many-select/many-select.vue"
export default component.exports